import { Component, OnChanges, Input } from '@angular/core';
import {
  Conference,
  Timeline,
  Room,
  DateTimeFrame,
  Cluster,
  CONFERENCE_TYPES,
 } from '../../../shared';

@Component({
  selector: 'app-cluster-schedule',
  templateUrl: './cluster-schedule.component.html',
  styleUrls: ['./cluster-schedule.component.css']
})
export class ClusterScheduleComponent implements OnChanges {
  @Input() cluster: Cluster;
  @Input() conferences: Conference[];
  @Input() dateTimeFrame: DateTimeFrame;
  tableMatrix: Map<Room, Map<Timeline, Conference>>;

  constructor() { }

  ngOnChanges() {
    if (this.cluster && this.conferences && this.dateTimeFrame) {
      this.parseConferences();    
    }
  }

  /**
   * Fills up tableMatrix object with dates, timelines and corresponding conferences
   */
  parseConferences() {
    this.tableMatrix = new Map<Room, Map<Timeline, Conference>>();

    for (let room of this.cluster.rooms) {
      this.tableMatrix.set(room, new Map<Timeline, Conference>());

      for (let timeline of this.dateTimeFrame.timelines) {
        this.tableMatrix.get(room).set(timeline, null);

        for (let conference of this.conferences) {
          if (room.name === conference.room.name && timeline.id === conference.timelines[0].id) {
              this.tableMatrix.get(room).set(timeline, conference);
          }
        }
      }
    }
  }

  iffy(conference: Conference): boolean {
    return conference.type == CONFERENCE_TYPES.IFFY;
  }

  /**
   * Utilized in the template, during schedule table constructing.
   * 
   * @param date 
   * @param timeline 
   */
  isEmptyCell(room: Room, timeline: Timeline) {
    if (this.conferences) {
      for (let conference of this.conferences) {
        if (conference.room.name === room.name && conference.timelines.find(t => t.id === timeline.id)) {
            return false;
          }
      }
      return true;
    }
  }

  /**
   * Utilized in the template, during schedule table constructing.
   * Handles sibling conferences (end of the first is start of the second)
   * 
   * @param date 
   * @param timeline 
   */
  isNotPresent(timeline: Timeline, room: Room): boolean {
    for (let c of Array.from(this.tableMatrix.get(room).values())) {
      if (c && c.timelines[c.timelines.length - 1].finish.hour === timeline.start.hour) {
        return false;
      }
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/schedule/components/cluster-schedule/cluster-schedule.component.ts